var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 83,
    fill: "none",
    viewBox: "0 0 82 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EFF3FB",
    d: "M68.333 77.567H13.667V5.817H51.25L68.333 22.9v54.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5071BB",
    fillOpacity: 0.35,
    d: "M65.77 24.608H49.543V8.38L65.77 24.61z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5071BB",
    d: "M27.333 36.567h29.042v3.416H27.333v-3.416zM27.333 43.4h22.209v3.417H27.333V43.4zM27.333 50.233h29.042v3.417H27.333v-3.417zM27.333 57.067h22.209v3.416H27.333v-3.416z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon-document.c29873fa08699c8b9b473eab5fd5927d.svg";
export { ForwardRef as ReactComponent };